export default __webpack_public_path__ + "static/media/widget-increase.63e4c56d.svg";